module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("For my father—who I lost this past year, I wish I had been as good to"), _c('br'), _vm._v("you as you were to me. Twenty-twenty hindsight can be a horrible"), _c('br'), _vm._v("and haunting thing. I can only hope and pray that you could see"), _c('br'), _vm._v("beyond my youth, see the man, and know in your heart"), _c('br'), _vm._v("I tried to be the best I could be.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("For Roxie—a cousin, now a sister, for enduring the unendurable,"), _c('br'), _vm._v("the loss of a child, it should happen to no one in the entire world."), _c('br'), _vm._v("My heart is broken for you.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("For Maribeth—to the ghosts of youth, may we forever be haunted"), _c('br'), _vm._v("and happier for it."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0